import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';
import { getAdminSecret } from './adminService';

const base = `${API_HOST}/api/admin/dreamina-proxy-library`;
const headers = () => ({ 'X-Admin-Secret': getAdminSecret() });

export const readDreaminaProxyGroup = (signal) => authenticatedFetch(`${base}/group-info`, {
  headers: headers(), signal,
});

export const listDreaminaProxyGroups = (projectName, signal) => authenticatedFetch(
  `${base}/groups?${new URLSearchParams({ projectName, pageNumber: '1', pageSize: '100' })}`,
  { headers: headers(), signal },
);

export const listDreaminaProxyAssets = (signal) => authenticatedFetch(`${base}/assets?pageNumber=1&pageSize=100`, {
  headers: headers(), signal,
});

export const createDreaminaProxyGroup = (body) => authenticatedFetch(`${base}/create-group`, {
  method: 'POST', headers: { ...headers(), 'Content-Type': 'application/json' }, body: JSON.stringify(body),
});

export const bindDreaminaProxyGroup = (body) => authenticatedFetch(`${base}/bind-group`, {
  method: 'POST', headers: { ...headers(), 'Content-Type': 'application/json' }, body: JSON.stringify(body),
});
